module.exports = __webpack_public_path__ + "outline-icons.ef60a4f6c25ef7f39f2d.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/outline-icons.woff
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/outline-icons.woff
// module chunks = styles